module.exports = __webpack_public_path__ + "img/complete_course.a1e0739d.png";